var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b1t-okraina-page-loader",class:!this.$store.state.isLoading ? 'done' : ''},[_c('div',{staticClass:"wrapper"},[_c('b1t-okraina-loader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }